// src/quiz/gre-mock9/index.js
// GRE Mock 9 — props for the shared Gre_verbal / Gre_quantitative /
// Gre_analytical components. Test names end in "Mock 9" so the profile
// keeps these results apart from the other mocks.
import verbalQuestions from "./verbalData";
import { section1Questions, section2Questions } from "./quantitativeData";

export const greMock9 = {
  verbal: {
    questions: verbalQuestions,
    testName: "GRE Verbal Reasoning Mock 9",
    title: "GRE Verbal Reasoning — Mock 9",
  },
  quantitative: {
    section1: section1Questions,
    section2: section2Questions,
    testName: "GRE Quantitative Reasoning Mock 9",
    title: "GRE Quantitative Reasoning — Mock 9",
  },
  analytical: {
    testName: "GRE Analytical Writing Mock 9",
    title: "GRE Analytical — Mock 9",
    prompt:
      "\"Universities should place greater emphasis on teaching students how to think critically and learn independently than on providing specialized knowledge for specific careers.\"",
    directions:
      "Write a response in which you discuss the extent to which you agree or disagree with the statement and explain your reasoning for the position you take. In developing and supporting your position, you should consider ways in which the statement might or might not hold true.",
    topicKeywords: [
      "universit", "educat", "critical", "think", "special", "career",
      "knowledge", "skill", "student", "learn", "employ", "curricul",
      "profession", "independent", "graduate", "workforce",
    ],
  },
};
